import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { NgModule, ErrorHandler, provideZoneChangeDetection } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { HttpClient, HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from "@angular/common/http";

//  Tranlation set up
import { TranslateModule, TranslateLoader } from "@ngx-translate/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
// AoT requires an exported function for factories

export const createTranslateLoader = (http: HttpClient) =>
  new TranslateHttpLoader(http, "/assets/i18n/", ".json");

// export function getToken() {
//     return localStorage.getItem('access_token');
// }

import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { LandingPageComponent } from "./components/landing-page/landing-page.component";

import { environment } from "../environments/environment";
import { materialModules } from "./material.module";
import { PermissionComponent } from "./components/permission/permission.component";
import { EditContentComponent } from "./components/edit-content/edit-content.component";
import { ProfileService } from "./services/profile-service/profile.service";
import { PortalAdminService } from "./services/portal-admin-service/portal-adimin.service";
import { AccessDeniedComponent } from "./components/access-denied/access-denied.component";
import { ErrorComponent } from "./components/error/error.component";
import { CanActivateService } from "./services/can-activate/can-activate.service";
import { BrandAccountComponent } from "./components/brand-account/brand-account.component";
import { MrcComponent } from "./components/mrc/mrc.component";
import { RecommitProcessComponent } from "./components/recommit-process/recommit-process.component";
import { FailedRecommitsComponent } from "./components/failed-recommits/failed-recommits.component";
import { PreviewContentComponent } from "./components/preview-content/preview-content.component";
import { RewardsPermissionComponent } from "./components/rewards-permission/rewards-permission.component";
import { MarkdownPipe } from "./pipes/markdown.pipe";
import { HttpClientInterceptor } from "./interceptors/httpClient.interceptor";
import { AuthService } from "./services/auth/auth.service";
import { SsoComponent } from "./components/sso/sso.component";
import { CallbackComponent } from "./components/callback/callback.component";
import { AppInsightsErrorHandler, AppInsightsModule, AppInsightsConfig } from '@overtur/app-insights';
import { ApplicationInsightsService } from "./services/app-insight/app-insight.service";
import { NoticeDialogComponent } from './components/notice-dialog/notice-dialog.component';

const appInsightsConfig: AppInsightsConfig  = {
  appInsightsInstrumentationKey: environment.appInsights.instrumentationKey,
  appInsightsCorrelationDomains: environment.appInsights.correlationDomains,
}

@NgModule({ declarations: [
        AppComponent,
        CallbackComponent,
        LandingPageComponent,
        PermissionComponent,
        EditContentComponent,
        PreviewContentComponent,
        AccessDeniedComponent,
        ErrorComponent,
        BrandAccountComponent,
        MrcComponent,
        RecommitProcessComponent,
        FailedRecommitsComponent,
        RewardsPermissionComponent,
        SsoComponent,
        NoticeDialogComponent,
        MarkdownPipe,
    ],
    bootstrap: [AppComponent],
    exports: [TranslateModule], imports: [materialModules,
        BrowserModule,
        BrowserAnimationsModule,
        FormsModule,
        AppRoutingModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: createTranslateLoader,
                deps: [HttpClient],
            },
        }),
        AppInsightsModule], providers: [
            provideZoneChangeDetection(),
        HttpClient,
        ProfileService,
        PortalAdminService,
        CanActivateService,
        AuthService,
        {
            provide: HTTP_INTERCEPTORS,
            useClass: HttpClientInterceptor,
            multi: true,
        },
        ApplicationInsightsService,
        {
            provide: 'appInsightsEnv',
            useValue: appInsightsConfig,
        },
        {
            provide: ErrorHandler,
            useClass: AppInsightsErrorHandler,
        },
        provideHttpClient(withInterceptorsFromDi()),
    ] })
export class AppModule {}
